import { Popup, ErrorPopup, httpAxios } from "../../core/classes/BaseStore";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { Target } from "@/modules/targets/viewmodels/Target";
import { TargetInvitation } from "@/modules/targets/viewmodels/TargetInvitation";

import Vue from "vue";

export const state = {
  targets: [],
};

export const getters = Object.assign(
  {
    targets: (state) => {
      return state.targets;
    },
    target: (state) => (Id) => {
      return state.targets.find((e) => e.id === Id);
    },
    ongoingTargets: (state) => {
      return state.targets.filter((e) => e.status === "ongoing");
    },
    finishedTargets: (state) => {
      return state.targets.filter((e) => e.status === "finished");
    },
    failedTargets: (state) => {
      return state.targets.filter((e) => e.status === "failed");
    },
    unstartedTargets: (state) => {
      return state.targets.filter((e) => e.status === "unstarted");
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/targets",
    Target,
    {
      AfterShow: (name, data) => {
        let el = state.targets.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.targets.push(data);
        }
        return data;
      },
    },
    {
      /**
       * Create new target
       * this.$store.getters['target/api'].Custom.Create()
       */
      Create: async (Payload) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("post", process.env.VUE_APP_BASE_URL + "/api/targets/", Payload)
          .catch((err) => {
            throw Error(err);
          });

        let data = new Target(ApiResult);

        let foundElement = state.targets.find((a) => a.id === data.id);
        if (foundElement) {
          Object.assign(foundElement, data);
        } else {
          state.targets.push(data);
        }

        return data;
      },

      /**
       * Retry target
       * this.$store.getters['target/api'].Custom.Retry(Id)
       */
      Retry: async (Payload) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "post",
            process.env.VUE_APP_BASE_URL + `/api/targets/${Payload.id}/retry`,
            Payload
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = new Target(ApiResult);

        let foundElement = state.targets.find((a) => a.id === data.id);
        if (foundElement) {
          Object.assign(foundElement, data);
        } else {
          state.targets.push(data);
        }

        return data;
      },

      /**
       * Returns all system and my targets
       * this.$store.getters['target/api'].Custom.My()
       */
      My: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("get", process.env.VUE_APP_BASE_URL + "/api/targets/my", {})
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new Target(Entry);
        });

        Vue.set(state, "targets", data);

        return data;
      },

      /**
       * Returns all pending invitations for target
       * this.$store.getters['target/api'].Custom.Invitations(TargetId)
       */
      Invitations: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL +
              "/api/targets/" +
              Id +
              "/invitations",
            {}
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new TargetInvitation(Entry);
        });

        return data;
      },

      /**
       * Returns finished targets of period (days)
       * this.$store.getters['target/api'].Custom.FinishedPeriod()
       */
      FinishedPeriod: async (Days) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL + "/api/targets/finished-period",
            { params: { days: Days } }
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new Target(Entry);
        });

        data.forEach((e) => {
          let foundElement = state.targets.find((a) => a.id === e.id);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.targets.push(e);
          }
        });

        return data;
      },

      /**
       * Returns created targets of period (days)
       * this.$store.getters['target/api'].Custom.CreatedPeriod()
       */
      CreatedPeriod: async (Days) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL + "/api/targets/created-period",
            { params: { days: Days } }
          )
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new Target(Entry);
        });

        data.forEach((e) => {
          let foundElement = state.targets.find((a) => a.id === e.id);
          if (foundElement) {
            Object.assign(foundElement, e);
          } else {
            state.targets.push(e);
          }
        });

        return data;
      },
    }
  )
);

// mutations
export const mutations = {
  removeTarget: (state, TargetId) => {
    let targetIndex = state.targets.findIndex((e) => e.id === TargetId);
    if (targetIndex !== undefined || targetIndex !== null) {
      state.targets.splice(targetIndex, 1);
    }
  },

  updateTarget: (state, Target) => {
    let el = state.targets.find((e) => e.id === Target.id);
    el = Object.assign(el, Target);
  },

  finishTarget: (state, TargetId) => {
    let el = state.targets.find((e) => e.id === TargetId);
    Vue.set(el, "status", "finished");
  },
};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/targets",
  [],
  {
    async removeTarget({ commit }, TargetId) {
      commit("removeTarget", TargetId);
    },

    async updateTarget({ commit }, Target) {
      commit("updateTarget", Target);
    },

    async finishTarget({ commit }, TargetId) {
      commit("finishTarget", TargetId);
    },
  }
);
